<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-avatar v-on="on" :class="btnClass" :size="16" :disabled="disabled" @click="actionClick" v-if="size==='x-small'">
                <span class="white--text font-weight-bold text-subtitle-2">&nbsp;{{ text }}&nbsp;</span>    
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="20" :disabled="disabled" @click="actionClick" v-if="size==='small'">
                <span class="white--text font-weight-bold">&nbsp;{{ text }}&nbsp;</span>
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="25" :disabled="disabled" @click="actionClick" v-if="size==='default'">
                <span class="white--text font-weight-bold text-h6">&nbsp;{{ text }}&nbsp;</span>
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="30" :disabled="disabled" @click="actionClick" v-if="size==='large'">
                <span class="white--text font-weight-bold text-h5">&nbsp;{{ text }}&nbsp;</span>
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="40" :disabled="disabled" @click="actionClick" v-if="size==='x-large'">
                <span class="white--text font-weight-bold text-h4">&nbsp;{{ text }}&nbsp;</span>
            </v-avatar>
        </template>
        <span v-html="convertTextToHtml(tooltip)"></span>
    </v-tooltip>
</template>

<script>
    export default{ 
        props: {
            data: {
                required: true,               
            },
            icon: {
                type: String,
                required: false,  
                default: ""            
            },
            text: {
                type: String,
                required: false,  
                default: ""            
            },   
            tooltip: {
                type: String,
                required: false,
                default: "Click me",
            },     
            size: {
                type: String,
                required: false,
                default: "default",
            },
            color: {
                type: String,
                required: false,
                default: "primary",
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,                
            }
        },
        data() {
            return {
            }
        },
        computed: {
            btnClass: function () {
                return "action mx-1 " + this.color;
            }
        }, 
        methods: {
            actionClick() {
                this.$emit("actionClick", this.data);
            },
            convertTextToHtml(text) {
                return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
            },
        },
    }

</script>

<style scoped>
    .action {
        cursor: pointer;
    }
</style>